import { useEffect, useState } from 'react';
import { Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import '../components/ui/common.css';
import { analyticsAPI } from '../services/api';
import './Charts.css';

const Charts = () => {
    const [activeChart, setActiveChart] = useState('weight');
    const [period, setPeriod] = useState('month');
    const [weightData, setWeightData] = useState([]);
    const [workoutsData, setWorkoutsData] = useState([]);
    const [habitsData, setHabitsData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadChartData();
    }, [activeChart, period]);

    const loadChartData = async () => {
        setLoading(true);
        try {
            if (activeChart === 'weight') {
                const response = await analyticsAPI.getWeightChart(period);
                setWeightData(response.data.data.map(item => ({
                    date: new Date(item.date).toLocaleDateString('ru-RU', { month: 'short', day: 'numeric' }),
                    value: parseFloat(item.weight)
                })));
            } else if (activeChart === 'workouts') {
                const response = await analyticsAPI.getWorkoutsChart(period);
                setWorkoutsData(response.data.data.map(item => ({
                    date: new Date(item.date).toLocaleDateString('ru-RU', { month: 'short', day: 'numeric' }),
                    value: item.totalMinutes
                })));
            } else if (activeChart === 'habits') {
                const response = await analyticsAPI.getBadHabitsChart(period);
                setHabitsData(response.data.data.map(item => ({
                    date: new Date(item.date).toLocaleDateString('ru-RU', { month: 'short', day: 'numeric' }),
                    value: item.totalQuantity
                })));
            }
        } catch (error) {
            console.error('Error loading chart data:', error);
        } finally {
            setLoading(false);
        }
    };

    const periods = [
        { value: 'day', label: 'День' },
        { value: 'week', label: 'Неделя' },
        { value: 'month', label: 'Месяц' },
        { value: 'year', label: 'Год' }
    ];

    const charts = [
        { id: 'weight', label: 'Вес', icon: '⚖️' },
        { id: 'workouts', label: 'Тренировки', icon: '💪' },
        { id: 'habits', label: 'Привычки', icon: '🍷' }
    ];

    const renderChart = () => {
        if (loading) {
            return <div className="loading" style={{ padding: '4rem' }}>Загрузка...</div>;
        }

        let data = [];
        let label = '';
        let color = '#2563eb';
        let ChartComponent = LineChart;
        let DataComponent = Line;

        if (activeChart === 'weight') {
            data = weightData;
            label = 'Вес (кг)';
            color = '#2563eb';
        } else if (activeChart === 'workouts') {
            data = workoutsData;
            label = 'Минуты';
            color = '#10b981';
            ChartComponent = BarChart;
            DataComponent = Bar;
        } else if (activeChart === 'habits') {
            data = habitsData;
            label = 'Единицы';
            color = '#ef4444';
            ChartComponent = BarChart;
            DataComponent = Bar;
        }

        if (data.length === 0) {
            return (
                <div className="empty-state">
                    <div className="empty-state-icon">📊</div>
                    <p>Нет данных для отображения</p>
                </div>
            );
        }

        return (
            <ResponsiveContainer width="100%" height={400}>
                <ChartComponent data={data}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="date" />
                    <YAxis />
                    <Tooltip />
                    <DataComponent type="monotone" dataKey="value" stroke={color} fill={color} name={label} />
                </ChartComponent>
            </ResponsiveContainer>
        );
    };

    return (
        <div>
            <h1>Графики</h1>

            <div className="charts-tabs">
                {charts.map((chart) => (
                    <button
                        key={chart.id}
                        className={`chart-tab ${activeChart === chart.id ? 'active' : ''}`}
                        onClick={() => setActiveChart(chart.id)}
                    >
                        <span className="chart-tab-icon">{chart.icon}</span>
                        <span>{chart.label}</span>
                    </button>
                ))}
            </div>

            <div className="period-buttons">
                {periods.map((p) => (
                    <button
                        key={p.value}
                        className={`period-btn ${period === p.value ? 'active' : ''}`}
                        onClick={() => setPeriod(p.value)}
                    >
                        {p.label}
                    </button>
                ))}
            </div>

            <div className="chart-container">
                {renderChart()}
            </div>
        </div>
    );
};

export default Charts;
